import { COUPON_CAMPAIGNS, COUPON_TYPES } from '../constants.js';
import { BaseMenuEntityConfiguration } from '../entityConfigs/index.js';
export default new BaseMenuEntityConfiguration({
    consumable: false,
    filters: [
        {
            name: 'type',
            options: COUPON_TYPES,
            type: 'Select',
        },
        {
            name: 'campaign',
            options: COUPON_CAMPAIGNS,
            type: 'Select',
        },
        {
            name: 'promotional',
            type: 'Boolean',
        },
        {
            name: 'internal',
            type: 'Boolean',
        },
    ],
    hasDescription: true,
    hasHours: true,
    hasImage: false,
    hasVariations: false,
    hasPos: false,
    lists: [
        {
            collection: 'Category',
            name: 'redeemableCategories',
        },
        {
            collection: 'Item',
            name: 'redeemableItems',
        },
        {
            collection: 'Category',
            name: 'purchaseableCategories',
        },
        {
            collection: 'Item',
            name: 'purchaseableItems',
        },
    ],
    name: 'Coupon',
    options: {
        amount: 0,
        campaign: null,
        code: '',
        end: null,
        maxQuantity: null,
        min: 0,
        promotional: false,
        resetPeriod: null,
        start: null,
        type: 'ticket-percent',
        redeemableChannels: [],
        redeemableOrderTypes: [],
        internal: false,
    },
    pluralizedName: 'Coupons',
    sellable: false,
    sortKeys: ['amount'],
    unlinkedOptions: [],
    version: 9,
});
//# sourceMappingURL=coupon.js.map